module.exports = __webpack_public_path__ + "static/3-db60e4f1f35cf9d2ee5be39ece7892a6.jpg";